export const contactsExportType = {
	linkedInContactsSearchPage: 'LinkedInContactsSearchPageExport',
	linkedInGroupContactsPage: 'LinkedInGroupContactsPageExport',
	linkedInMyConnections: "LinkedInMyConnectionsExport",
	salesNavigatorContactsSearchPage: 'SalesNavigatorContactsSearchPageExport',
	salesNavigatorLeadsListPage: 'SalesNavigatorLeadsListPageExport',
	contactsPublicIdentifierList: 'ContactsPublicIdentifierListExport',
	csvContactsList: 'CsvContactsListExport'
} as const
